import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import logo from '../assets/logo.png';

const Navbar = () => {
  return (
    <div className="w-full fixed top-0 z-50 bg-white shadow-md">
      <div className="flex items-center justify-between h-20 px-6 md:px-20">
        {/* Logo */}
        <a href="/" className="focus:outline-none">
          <img src={logo} alt="Logo" className="h-12 w-auto object-contain" />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex space-x-8">
          {['About', 'Features', 'Solutions', 'Pricing'].map((item) => (
            <li key={item} className="hover:text-[#427cfc]">
              <Link smooth to={`/#${item.toLowerCase()}`}>{item}</Link>
            </li>
          ))}
        </ul>

        {/* Desktop Call to Action */}
        <div className="hidden md:block">
          <Link
            smooth
            to="/#pricing"
            className="bg-[#427cfc] text-white px-6 py-3 rounded-3xl font-medium hover:scale-105 transition-transform"
          >
            Get Started
          </Link>
        </div>

        {/* Mobile menu wrapper with peer */}
        <div className="md:hidden relative">
          <input type="checkbox" id="menu-toggle" className="peer hidden" />

          {/* Toggle Button */}
          <label htmlFor="menu-toggle" className="cursor-pointer z-50 relative">
            <svg
              className="w-8 h-8 text-[#427cfc]"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path
                className="peer-checked:hidden"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                className="hidden peer-checked:block"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </label>

          {/* Slide-in Mobile Menu */}
          <div className="fixed top-0 left-0 h-full w-[60vw] bg-white z-40 transform -translate-x-full peer-checked:translate-x-0 transition-transform duration-300 ease-in-out">
            <div className="h-20 flex items-center px-6 border-b border-gray-300">
              <a href="/">
                <img src={logo} alt="Logo" className="h-12 w-auto object-contain" />
              </a>
            </div>
            <ul className="flex flex-col p-4 space-y-4">
              {['About', 'Features', 'Solutions', 'Pricing'].map((item) => (
                <li key={item} className="border-b border-gray-200 pb-2 hover:text-[#427cfc]">
                  <Link smooth to={`/#${item.toLowerCase()}`} onClick={() => document.getElementById('menu-toggle').checked = false}>
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="px-4 mt-4">
              <Link
                smooth
                to="/#pricing"
                className="block bg-[#427cfc] text-white px-6 py-2 rounded-3xl font-medium text-center hover:scale-105 transition-transform"
                onClick={() => document.getElementById('menu-toggle').checked = false}
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
